import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="text-center">
      <h1
        className="display-1 text-danger fw-bold"
        style={{ paddingTop: "8rem" }}
      >
        404
      </h1>
      <p>
        We could not find the page you are looking for. Please check for typos.
      </p>

      <p>
        Click{" "}
        <Link
          to="/"
          style={{ textDecoration: "none", color: "blue", fontStyle: "italic" }}
        >
          here
        </Link>{" "}
        to return to <span className="fw-bold  text-success">Lanre Adeolu</span>{" "}
        website
      </p>
    </div>
  );
};

export default NotFound;
